import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';

import {
  fetchUserProfile,
  integrationAuth,
} from '../actions/Auth';

import { sendTrackingEvent } from '../helpers';

import Loading from '../components/Loading';

const IntegrationAuthCallback = ({
  dispatch,
  history,
  location,
  match,
}) => {
  const intl = useIntl();

  const [error, setError] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');
    if (!code) {
      setError(intl.formatMessage({ defaultMessage: 'Incorrect authorization code' }));
    } else {
      dispatch(integrationAuth(match.params.serviceId, code, urlParams.get('state')))
        .then((response) => {
          if (response.redirect_url) {
            sendTrackingEvent('integration-connected', { service: match.params.serviceId });
            dispatch(fetchUserProfile());
            history.push(response.redirect_url);
          }
          if (response.error) {
            setError(response.message);
          }
        })
        .catch((e) => {
          setError(e.response.data.message);
        });
    }
  }, [location.search, match.params, dispatch, history, intl]);

  return (
    <div className="connect-wrapper">
      {error ? (
        <Fragment>
          <h3>{intl.formatMessage({ defaultMessage: 'Something went wrong' })}</h3>
          <p>{error}</p>
          <p>{intl.formatMessage({ defaultMessage: 'Please go back and try again' })}</p>
        </Fragment>
      ) : (
        <Fragment>
          <h3>{intl.formatMessage({ defaultMessage: 'Connecting...' })}</h3>
          <Loading />
        </Fragment>
      )}
    </div>
  );
};

IntegrationAuthCallback.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withRouter(connect()(IntegrationAuthCallback));
